import './index.css'

const Contact = () => (
  <div className="main-container">
    <img
      src="https://assets.ccbp.in/frontend/react-js/contact-blog-img.png"
      alt="contact"
      width="250px"
      className="img"
    />
    <h1 className="main-text">Contact</h1>
  </div>
)

export default Contact
